<label class="search" [class.search--expand]="expandSearch">
  <app-icon class="icon" icon="search"></app-icon>
  <input type="text"
         autofocus
         data-test="search-users"
         class="input normal"
         [class.input--expand]="expandSearch"
         [placeholder]="placeholder | customLocale"
         [formControl]="formControl"
         (keyup.enter)="onPressEnter($event.target.value)">
  <app-icon class="icon-close" icon="close-search"
            [class.icon-close--expand]="expandSearch"
            (click)="clearSearchForm()">
  </app-icon>
</label>
